import { render } from "./ClozeResult.vue?vue&type=template&id=014e3dac&scoped=true"
import script from "./ClozeResult.vue?vue&type=script&lang=js"
export * from "./ClozeResult.vue?vue&type=script&lang=js"

import "./ClozeResult.vue?vue&type=style&index=0&id=014e3dac&scoped=true&lang=css"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014e3dac"]])

export default __exports__